import * as React from 'react';
export var FeaturesContext = React.createContext({});
export var FeaturesProvider = function (_a) {
    var children = _a.children, features = _a.features;
    return (React.createElement(FeaturesContext.Provider, { value: features, children: children }));
};
export var useFeatures = function () { return React.useContext(FeaturesContext); };
